import styled, { css } from 'styled-components';
import { gray3 } from '../../globals/colors';
import { bubbleEventMixin, bubbleMixin, flexCenterMixin, visuallyHiddenMixin } from '../../styles/mixins';

export const clearButtonIconCss = css`
    font-size: .75em;
`;

export const clearButtonCss = css`
    ${bubbleMixin}
    ${bubbleEventMixin}
    height: calc(1em + 1rem);
    width: calc(1em + 1rem);
    position: absolute;
    color: white;
    right: -.25rem;
    top: -.25rem;
    ${flexCenterMixin}
    border-color: ${gray3};
    clip: auto;
`;

/**
 * (1) This button is visually hidden, but shown on hover and focus.
 *     In this way users can still tab to it, and it is also only shown on hover.
 */
export const ClearButton = styled.button`
    ${visuallyHiddenMixin} /* (1) */

    &:focus {
        ${clearButtonCss}
    }

    &:hover {
        ${clearButtonCss}
    }
`;

export const SidePanelFrameLeftContent = styled.div`
    z-index: 1;
    position: relative;
    ${flexCenterMixin};
    flex-direction: column;
    margin-right: calc(-1em - 1rem);
`;

export const SidePanelFrameTopBotSlot = styled.div`
    height: calc(1em + 1rem);
    width: calc(1em + 1rem);
`;

export const SidePanelFrameRoot = styled.div`
    ${flexCenterMixin}
    flex-direction: row-reverse;
    position: relative;
    margin-bottom: .5em;

    &:hover > ${ClearButton} {
        ${clearButtonCss}
    }
`;

export const SidePanelFrameMidSlot = styled.div`
    ${flexCenterMixin};
    margin: .5em 0;
    height: calc(2em + 2rem);
    width: calc(2em + 2rem);
`;
